export default __webpack_public_path__ + "static/media/estateagents.15f6cd45.jpg";